var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoback(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.601175 6.86131L6.31518 12.5773C6.37473 12.637 6.44546 12.6844 6.52332 12.7167C6.60118 12.7491 6.68465 12.7658 6.76897 12.7659C6.85328 12.766 6.93679 12.7494 7.01472 12.7173C7.09266 12.6851 7.16349 12.6379 7.22318 12.5783C7.28286 12.5188 7.33023 12.448 7.36258 12.3702C7.39494 12.2923 7.41163 12.2088 7.41173 12.1245C7.41182 12.0402 7.39531 11.9567 7.36313 11.8788C7.33095 11.8008 7.28373 11.73 7.22417 11.6703L1.96317 6.40831L7.22617 1.15131C7.34711 1.0305 7.41511 0.866602 7.4152 0.695663C7.4153 0.524723 7.34748 0.360748 7.22668 0.239809C7.10587 0.11887 6.94197 0.0508751 6.77103 0.0507813C6.60009 0.0506876 6.43611 0.118503 6.31518 0.239309L0.600175 5.95131C0.480733 6.07269 0.413876 6.23622 0.414063 6.40651C0.41425 6.57681 0.481467 6.74019 0.601175 6.86131Z",
    fill: "#677294"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoback);
export default __webpack_public_path__ + "static/media/goback.93e707c632cf2c41a88c3382ed32c9a7.svg";
export { ForwardRef as ReactComponent };